export const isArray = v => Array.isArray(v);